import type { en } from './en';

export const ua: typeof en = {
    app_loading:             "Завантаження...",
    app_sign_in_tab:         "Увійти",
    app_sign_up_tab:         "Реєстрація",

    sign_in_email:           "Email",
    sign_in_password:        "Пароль",
    sign_in_submit:          "Увійти",
    sign_in_submitting:      "Вхід...",

    sign_up_full_name:       "Повне ім'я",
    sign_up_email:           "Email",
    sign_up_password:        "Пароль",
    sign_up_submit:          "Створити акаунт",
    sign_up_submitting:      "Створення акаунту...",

    dashboard_title:         "Проєкти",
    dashboard_empty:         "Немає проєктів. Створіть один через меню акаунту.",
    dashboard_open_project:  "Відкрити як новий проєкт",

    code_pane_changes:       "Зміни",
    code_pane_diff:          "Diff",
    code_pane_explorer:      "Провідник",
    code_pane_editor:        "Редактор",
    code_edit_mode_on:       "Увімкнути режим редагування",
    code_edit_mode_off:      "Вимкнути режим редагування",
    code_no_files:           "Немає відкритих файлів",
    code_file_deleted:       "Цей файл було видалено",
    code_collapse_tree:      "Згорнути дерево",
    code_more_actions:       "Більше дій",
    code_find:               "Знайти",

    nav_code:                "Код",
    nav_review:              "Огляд",
    nav_deploy:              "Деплой",
    nav_agent:               "Агент",

    deploy_title:            "Деплой",
    deploy_empty:            "Немає налаштованих розгортань",
    deploy_btn_frontend:     "Деплой Frontend",
    deploy_btn_backend:      "Деплой Backend",
    deploy_running:          "Деплою…",
    deploy_logs_title:       "Логи",
    deploy_logs_clear:       "Очистити",
    deploy_custom_placeholder: "Назва сервісу…",
    deploy_btn_custom:       "Деплой",
    deploy_stop:             "Стоп",

    account_menu_label:      "Меню акаунту",
    account_no_projects:     "Немає проєктів",
    account_new_project:     "+ Новий проєкт",
    account_close_project:   "Закрити проєкт",
    account_settings:        "Налаштування",
    account_setup_agent:     "Налаштувати агента",
    account_sign_out:        "Вийти",

    settings_title:          "Налаштування",
    settings_tab_appearance: "Вигляд",
    settings_tab_claude:     "Claude",
    settings_tab_tabs:       "Вкладки",
    settings_tab_ssh_keys:   "Ключі",
    settings_theme:          "Тема",
    settings_language:       "Мова",
    settings_max_open_tabs_desktop: "Макс. відкритих вкладок (desktop)",
    settings_max_open_tabs_mobile:  "Макс. відкритих вкладок (mobile)",
    settings_claude_model:         "Модель",
    settings_claude_model_default: "За замовчуванням",
    settings_claude_effort:        "Зусилля",
    settings_claude_effort_default: "За замовчуванням",
    settings_claude_effort_low:    "Низьке",
    settings_claude_effort_medium: "Середнє",
    settings_claude_effort_high:   "Високе",
    settings_claude_effort_max:    "Максимальне",
    settings_cancel:         "Скасувати",
    settings_save:           "Зберегти",

    new_project_title:       "Новий проєкт",
    new_project_placeholder: "Назва проєкту",
    new_project_cancel:      "Скасувати",
    new_project_create:      "Створити",

    agent_placeholder:       "Опишіть завдання...",
    agent_send:              "Надіслати",
    agent_stop:              "Зупинити",
    agent_thinking:          "Думаю…",
    agent_working:           "Працюю…",
    agent_approve:           "Дозволити",
    agent_approve_always:    "Завжди дозволяти",
    agent_deny:              "Відмовити",
    agent_permission_responded: "Відповідь надіслана",
    agent_new_session:          "Новий сеанс",
    agent_close_session:        "Закрити сеанс",
    agent_close_session_confirm: "Закрити цей сеанс?",
    agent_session_settings:     "Налаштування сеансу",
    agent_context_toggle:        "Перемкнути контекст файлу",
    agent_context_remove:        "Видалити контекст файлу",
    agent_readonly_toggle:       "Перемкнути режим лише для читання (не редагувати код)",
    agent_backend:               "Backend",
    agent_backend_json:          "JSON",
    agent_backend_vscode:        "VS Code",

    file_open_dir:           "Відкрити директорію",
    file_empty:              "Порожньо",
    file_empty_dir:          "Порожня директорія",
    file_delete_title:       "Видалити",
    file_delete_confirm:     "Назавжди видалити \"{path}\" з диску? Це неможливо скасувати.",
    file_delete_btn:         "Видалити",
    file_add_to_context:     "Додати до контексту",
    file_create_folder_title: "Створити папку",
    file_create_folder_placeholder: "Назва папки",
    file_create_folder_btn:  "Створити",
    file_create_file_title:  "Створити файл",
    file_create_file_placeholder: "Назва файлу",
    file_create_file_btn:    "Створити",
    file_rename_title:       "Перейменувати",
    file_rename_placeholder: "Нова назва",
    file_rename_btn:         "Перейменувати",

    review_changes:          "Зміни",
    review_staged:           "Додані",
    review_unstaged:         "Незбережені",
    review_untracked:        "Невідстежені",
    review_conflicts:        "Конфлікти",
    review_conflict_label:   "конфлікт",
    review_resolved:              "Вирішено",
    review_resolved_label:        "вирішено",
    review_pending_stash_merge:   "Після коміту локальні зміни буде застосовано знову і може знадобитися ще одне злиття.",
    review_accept_mine:      "Прийняти мої",
    review_accept_theirs:    "Прийняти їхні",
    review_accept_both:      "Прийняти обидва",
    review_accept_committed: "Прийняти закомічені",
    review_accept_stash:     "Прийняти stash",
    review_save:             "Зберегти",
    review_edit:             "Редагувати",
    review_done_editing:     "Завершити редагування",
    review_ctx_stage:        "Додати",
    review_ctx_unstage:      "Прибрати",
    review_ctx_revert:       "Відновити",
    review_untracked_short:  "U",
    review_no_changes:       "Немає змін",
    review_no_commits:       "Немає комітів",
    review_detached_head:    "Відокремлений HEAD",
    review_select_file:      "Оберіть файл для перегляду diff",
    review_no_changes_for_file: "Немає змін для {path}",
    review_no_git:           "Немає git-репозиторію",
    review_no_git_desc:      "Проєкт \"{name}\" не знаходиться в git-репозиторії.",
    review_no_git_desc_generic: "Цей проєкт не знаходиться в git-репозиторії.",
    review_init_git:         "Ініціалізувати git-репозиторій",
    review_initializing:     "Ініціалізація...",
    review_agent_offline:    "Агент офлайн",
    review_agent_offline_desc: "Агент не підключений. Запустіть процес агента для роботи з git.",
    review_error:            "Помилка завантаження даних git",
    review_dismiss_error:    "Закрити",
    review_merge_required:   "Потрібне злиття",
    review_merge_required_desc: "Цей pull потребує злиття (гілки розійшлися або є незакомічені зміни). Нічого не змінено. Почніть злиття, щоб узгодити.",
    review_start_merge:      "Почати злиття",
    review_merging:          "Злиття...",
    review_identity_required: "Потрібна ідентичність Git",
    review_identity_required_desc: "Вкажіть ім'я та e-mail для автора коміту злиття.",
    review_identity_name:    "Ім'я",
    review_identity_email:   "E-mail",
    review_save_identity:    "Зберегти та злити",
    review_saving_identity:  "Збереження...",
    review_retry:            "Повторити",
    review_no_branch:        "немає гілки",
    review_new_branch_btn:   "+",
    review_new_branch_dialog_title: "Створити нову гілку",
    review_new_branch_placeholder: "Назва гілки",
    review_new_branch_option:       "Нова гілка",
    review_create_branch:    "Створити",
    review_creating_branch:  "Створення...",
    review_vault:                   "Vault",
    vault_configure_banner:         "Налаштувати vault",
    vault_configure_modal_title:    "Налаштувати Vault",
    vault_add_new:                  "Додати vault",
    vault_unnamed:                  "Без назви",
    vault_name_label:               "Назва",
    vault_engine_label:             "Рушій",
    vault_engine_local_folder:      "Локальна папка",
    review_branch_search_placeholder: "Пошук гілок...",
    review_branch_no_results:       "Нічого не знайдено",
    review_commits_ahead:           "Комітів попереду віддаленого",
    review_commits_behind:          "Комітів позаду віддаленого",
    review_switch_branch_title:             "Змінити гілку",
    review_switch_branch_switch_btn:        "Переключитись на",
    review_switch_branch_checkout_current_btn: "Checkout поточної",
    review_commit_placeholder: "Повідомлення коміту",
    review_commit_btn:       "Коміт",
    review_commit_merge_btn: "Закомітити злиття",
    review_merge_in_progress: "Злиття триває — закомітьте, щоб завершити.",
    review_merge_in_progress_banner: "Злиття триває — вирішіть конфлікти та закомітьте або перервіть, щоб відновити попередній стан.",
    code_merge_in_progress: "Триває злиття — розв'яжіть конфлікти та зробіть коміт",
    review_abort_merge:       "Перервати",
    review_aborting:         "Переривання...",
    review_committing:       "Надсилання...",

    review_remove_file_title:   "Відновити зміни",
    review_remove_file_confirm: "Відновити зміни до \"{path}\"? Це неможливо скасувати.",
    review_remove_file_btn:     "Відновити",

    review_checkout_conflict_title: "Конфлікт перемикання",
    review_checkout_conflict_desc:  "Локальні зміни будуть перезаписані при переключенні на \"{branch}\". Збережіть зміни в stash перед переключенням.",
    review_stash_placeholder:       "Назва stash (необов'язково)",
    review_stash_and_switch:        "Stash і переключити",
    review_stashing:                "Збереження в stash...",

    tabs_close_tab:                 "Закрити вкладку",
    tabs_close_other_tabs:          "Закрити інші вкладки",
    tabs_close_all_tabs:            "Закрити всі вкладки",

    ssh_keys_empty:                 "Ще немає SSH ключів.",
    ssh_keys_name_label:            "Назва",
    ssh_keys_name_placeholder:      "напр. ключ для розгортання",
    ssh_keys_private_label:         "Приватний ключ",
    ssh_keys_private_placeholder:   "-----BEGIN OPENSSH PRIVATE KEY-----",
    ssh_keys_public_label:          "Публічний ключ (необов'язково)",
    ssh_keys_public_placeholder:    "ssh-ed25519 AAAA...",
    ssh_keys_upload:                "Завантажити файл",
    ssh_keys_enter_manually:        "Ввести вручну",
    ssh_keys_add:                   "Додати ключ",
    ssh_keys_add_new:               "Додати новий ключ",
    ssh_keys_new_title:             "Новий ключ SSH",
    ssh_keys_cancel:                "Скасувати",
    ssh_keys_use:                   "Використати",
    ssh_keys_active:                "Активний",
    ssh_keys_remove:                "Видалити",
    ssh_keys_remove_title:          "Видалити ключ SSH",
    ssh_keys_remove_confirm:        "Видалити «{name}»? Цю дію не можна скасувати.",
};
